import {
  put, all, call, select, takeLatest,
} from 'redux-saga/effects';
import { getCurrentAuthHeader } from 'domain/fuse/auth/utils';
import { morphShipmentToUI } from 'domain/order/utils';
import { exception } from 'circe/logger';
import { show as showNotification } from 'circe/notifications/actions';
import * as I18n from 'circe/I18n';
import {
  fetch,
  fetching,
  fetched,
  updateStatus,
  updateLocation,
  failed,
  printWaybill,
} from './actions';
import { fetched as trackingFetched } from '../tracking/actions';
import * as api from './api';
import { getShipment } from './selectors';
import { morphUsingState } from './utils';

const doFetch = function* ({ payload }) {
  try {
    const { sid, iid } = payload;

    const state = yield select();

    yield put(fetching());

    const headers = yield call(getCurrentAuthHeader, state);

    const results = yield call(api.fetch, sid, iid, headers);

    if (!results) {
      throw new Error(`Shipment View failed to load ${sid}`);
    }

    const morphed = morphUsingState(morphShipmentToUI(results), state);

    yield put(fetched(morphed));
  } catch (e) {
    yield put(failed());
    exception(e);
  }
};

function* doSaveTracking({ payload }) {
  const state = yield select();

  const { status, location } = payload.shipment;

  const shipment = getShipment(state);

  if (shipment.quote.shipmentId !== payload.shipment.shipmentId) {
    return;
  }

  yield put(updateStatus(status));

  yield put(updateLocation(location));
}

function* doPrintWaybill(action) {
  const { payload: params = { waybill } } = action;

  try {
    const resp = yield call(api.printWaybill, params);
    if (!resp || !resp.file) {
      throw new Error('Unable to print waybill');
    }
    yield window.open(resp.file);
  } catch (e) {
    yield put(
      showNotification(
        I18n.str('unableToPrintTheWaybill', 'Unable to print the waybill.'),
        'error',
      ),
    );
    exception(e);
  }
}

export default function* () {
  yield all([
    takeLatest(fetch().type, doFetch),
    takeLatest(trackingFetched().type, doSaveTracking),
    takeLatest(printWaybill().type, doPrintWaybill),
  ]);
}
